export default {"src":"/_next/static/media/warning_info.285a06aa.svg","height":20,"width":20};